import { greekMessages } from '@/plugins/yup-localization';
import { BaseSchemaBuilder } from '@/views/checkouts/schemas/baseSchema';
import { isOfDrivingAge, isValidDate } from '@/views/checkouts/schemas/validators';
import * as yup from 'yup';

export const sharedEuroinsFields = (
    firstDriverAdditionalPremiumAge,
    secondDriverAdditionalPremiumAge,
    firstDriverAdditionalPremiumLicenseYears,
    secondDriverAdditionalPremiumLicenseYears,
    legalEntity,
    secondDriver,
    discountEntity,
    vehicleType
) => {
    let schema = {
        ...BaseSchemaBuilder(true, false, legalEntity, !legalEntity, discountEntity),
        tax_office: yup.string().required(),
        only_driver: yup.boolean().required(),
        name2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
        surname2: yup.string().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
        tax_no2: yup.string().when('only_driver', {
            is: false,
            then: s => s
                .matches(/^\d+$/, {
                    message: greekMessages.mixed.isValidAFM,
                })
                .length(9, greekMessages.mixed.isValidAFM)
                .required(),
        }),
        birthDate2: yup.object().when('only_driver', {
            is: false,
            then: s => s.shape({
                day: yup.string().required(),
                month: yup.string().required(),
                year: yup.string().required(),
            }).test('isOfDrivingAge', greekMessages.mixed.isOfDrivingAge, isOfDrivingAge)
            .test('isValidDate', greekMessages.mixed.isValidDate, isValidDate),
        }),
        license_years2: yup.number().when('only_driver', {
            is: false,
            then: s => s.required(),
        }),
    };

    return schema;
};


export const sharedEuroinsSchemaBuilder = (...args) => yup.object(sharedEuroinsFields(...args));
export default sharedEuroinsSchemaBuilder;
